// The contributor's page, reached from the link of a request: one question,
// one answer. The token in the URL is the only credential; nothing else of
// the dossier is shown.
import { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api/client";
import { useMutation, useResource } from "../api/resource";
import { ErrorState, Notice, SkeletonBlock } from "../components/ui";
import { formatDateTime, w } from "../i18n";

export function ContributePage() {
  const { token = "" } = useParams();
  const request = useResource(`contribution:${token}`, () => api.contribution(token));
  const submit = useMutation(api.answerContribution);
  const [answer, setAnswer] = useState("");
  const [sent, setSent] = useState(false);
  const data = request.data;
  const send = async () => { if (await submit.run(token, answer.trim())) { setSent(true); request.reload(); } };

  return <main className="ws-contribute">
    <div className="ws-brand" style={{ marginBottom: 16 }}><strong>SeaBird</strong> · {w("contribute.app")}</div>
    {request.loading && <SkeletonBlock lines={6} />}
    {request.error && <ErrorState title={w("contribute.invalid")} error={request.error} />}
    {data && <section className="ws-card ws-card-pad">
      <p className="ws-small ws-muted" style={{ marginTop: 0 }}>{data.entity_name} · {data.report_type} {data.reporting_year}</p>
      <h1 style={{ margin: "0 0 4px", fontSize: 22 }}>{w("contribute.title", { name: data.contributor_name || "" })}</h1>
      <p className="ws-muted" style={{ marginTop: 0 }}>{w("contribute.context", { code: data.section_code, title: data.section_title,
        asker: data.asked_by, date: formatDateTime(data.asked_at) })}</p>
      <blockquote className="ws-quote">{data.question}</blockquote>
      {data.status === "cancelled" && <Notice tone="neutral">{w("contribute.cancelled")}</Notice>}
      {data.status === "answered" && <Notice tone="positive" title={w(sent ? "contribute.thanks" : "contribute.alreadyAnswered")}>
        <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{data.answer}</p></Notice>}
      {data.status === "open" && <>
        <div className="ws-field" style={{ marginTop: 16 }}>
          <label htmlFor="contribution">{w("contribute.answer")}</label>
          <textarea id="contribution" className="ws-textarea" rows={8} value={answer} onChange={e => setAnswer(e.target.value)} />
          <span className="ws-small ws-faint">{w("contribute.hint")}</span>
        </div>
        {submit.error && <ErrorState title={w("contribute.sendError")} error={submit.error} />}
        <button className="ws-btn primary" disabled={submit.pending || !answer.trim()} onClick={send}>{w("contribute.send")}</button>
      </>}
    </section>}
  </main>;
}
